import React from 'react';
import { useFooterPanel } from './FooterPanelContext';
import { FOOTER_PANEL_TABS } from './FooterPanelContext';
import { ApiCallsTab } from './tabs';

const TAB_CONTENT_MAP = {
  [FOOTER_PANEL_TABS.API_CALLS]: ApiCallsTab,
};

function FooterPanelContent() {
  const { activeTab } = useFooterPanel();
  const TabComponent = TAB_CONTENT_MAP[activeTab] || ApiCallsTab;

  return (
    <div className="varexe-footer-panel-content">
      <TabComponent />
    </div>
  );
}

export default FooterPanelContent;
